import * as Immutable from "immutable";
import serialize from "services/serialize";

export class BillingPlanRecord extends Immutable.Record({
  id: null,
  clientId: "",
  customer: "",
  availablePlans: "",
  currentPeriodEnd: "",
  remainingConversationUsage: "",
  card: "",
  subscription: "",
  phoneNumber: ""
}) {}

const billingPlanMap = Immutable.Map({
  record: new BillingPlanRecord(),
  isLoading: true
});

export const billingPlan = (state = billingPlanMap, action) => {
  switch (action.type) {
    case "GET_BILLINGS_REQUEST":
      return state.set("isLoading", true);
    case "GET_BILLINGS_SUCCESS":
    case "POST_CREDIT_SUCCESS":
    case "UPDATE_CREDIT_SUCCESS":
      return state.merge({
        record: new BillingPlanRecord(serialize(action.response.data.billing_plan)),
        isLoading: false
      });
    case "UPDATE_PLAN_SUCCESS":
      return state.setIn(["record", "subscription", "planId"], action.plan.get("planId"));
    case "UPDATE_BILLING_CUSTOMER_SUCCESS":
      return state.mergeIn(["record", "customer"], {
        email: action.email,
        description: action.companyName
      }).setIn(["record", "phoneNumber"], action.phoneNumber);
    case "GET_BILLINGS_FAILURE":
      return state.set("isLoading", false);
    default:
      return state;
  }
};
